<script setup lang="ts">
import { AppFlicker, AppSvgIcon } from '@libs/ui';

import ActivityDetailsFooter from '../ticketsSelector/ActivityDetailsFooter.vue';

interface TicketsSelectorDesktopLoaderEmits {
  (event: 'close'): void;
}
const emit = defineEmits<TicketsSelectorDesktopLoaderEmits>();
</script>

<template>
  <div class="tickets-selector-desktop-loader">
    <div class="modal-content">
      <div class="activities-dates-wrapper">
        <div class="dates-scroll">
          <AppFlicker
            v-for="n in 5"
            :key="n"
            width="spacing-80"
            height="spacing-48"
            border-radius="border-radius-8"
            class="date-item"
          />
        </div>
      </div>
      <div v-for="n in 2" :key="n" class="tickets-container">
        <div class="ticket-loader">
          <div class="ticket-header">
            <div class="title">
              <AppSvgIcon name="activity" />
              <AppFlicker
                width="spacing-96"
                height="spacing-20"
                border-radius="border-radius-8"
                class="ticket-type"
              />
            </div>

            <AppFlicker
              width="spacing-96"
              height="spacing-32"
              border-radius="border-radius-8"
              class="ticket-pax-number"
            />
          </div>

          <div class="ticket-content">
            <div>
              <AppFlicker
                width="spacing-96"
                height="spacing-12"
                border-radius="border-radius-8"
                :margin="{ ySpacing: 'spacing-8' }"
              />
              <AppFlicker
                width="spacing-24"
                height="spacing-12"
                border-radius="border-radius-8"
                :margin="{ ySpacing: 'spacing-8' }"
              />
            </div>
            <AppFlicker
              width="spacing-96"
              height="spacing-32"
              border-radius="border-radius-8"
              class="selector-container"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-wrapper">
      <ActivityDetailsFooter @close="emit('close')" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.tickets-selector-desktop-loader {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  .modal-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 0;

    .activities-dates-wrapper {
      position: sticky;
      top: 0;
      background-color: var(--color-white);
      padding: var(--spacing-24) var(--spacing-24) var(--spacing-16);

      .dates-scroll {
        display: flex;
        gap: var(--spacing-12);
        overflow-x: auto;

        &::-webkit-scrollbar {
          display: none;
        }

        .date-item {
          flex-shrink: 0;
          padding-right: var(--spacing-96);
        }
      }
    }

    .tickets-container {
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: var(--spacing-12);
      padding: 0 var(--spacing-24) var(--spacing-24) var(--spacing-24);

      .ticket-loader {
        background-color: var(--color-neutral-10);
        border-radius: var(--border-radius-12);
        padding: var(--spacing-16);

        .ticket-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: var(--spacing-32);
          flex-direction: column;
          .title {
            display: flex;

            .ticket-type {
              margin-bottom: var(--spacing-32);
              margin-left: var(--spacing-24);
            }
          }

          .ticket-pax-number {
            padding-right: var(--spacing-32);
          }
        }

        .ticket-content {
          display: flex;
          justify-content: space-between;
          margin-bottom: var(--spacing-16);
          .selector-container {
            padding-right: var(--spacing-80);
          }
        }
      }
    }
  }
}
</style>
